import { render, staticRenderFns } from "./TagListComponent.vue?vue&type=template&id=7b9a1186&scoped=true&"
import script from "./TagListComponent.vue?vue&type=script&lang=js&"
export * from "./TagListComponent.vue?vue&type=script&lang=js&"
import style0 from "./TagListComponent.vue?vue&type=style&index=0&id=7b9a1186&lang=less&scoped=true&"
import style1 from "./TagListComponent.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9a1186",
  null
  
)

export default component.exports